(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lx-cart-locale-path"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker=document.querySelector('[data-lx-cart-locale-return]');
  if(!marker)return;
  const key='lx_cart_locale_return_v1';
  if(marker.dataset.lxCartLocaleReturn==='product'){
    const remember=()=>{
      try{sessionStorage.setItem(key,JSON.stringify({cart:marker.dataset.cartPath,from:location.pathname,created:Date.now()}));}catch(_){}
    };
    document.addEventListener('click',event=>{
      if(event.target.closest('button[name="add"],.product-form__submit,lx-mobile-purchase .lxmp-action'))remember();
    },true);
    window.addEventListener('builder-validate',remember);
    document.addEventListener('submit',event=>{
      if(event.target.matches('form[action*="/cart/add"]'))remember();
    },true);
    return;
  }
  try{
    const value=sessionStorage.getItem(key);
    if(!value)return;
    sessionStorage.removeItem(key);
    const saved=JSON.parse(value),age=Date.now()-saved.created;
    if(!Number.isFinite(age)||age<0||age>120000||location.pathname!=='/cart')return;
    if(typeof saved.cart!=='string'||!/^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?cart$/.test(saved.cart))return;
    const referrer=new URL(document.referrer);
    if(referrer.origin!==location.origin||referrer.pathname!==saved.from)return;
    const destination=new URL(saved.cart,location.origin);
    destination.search=location.search;
    destination.hash=location.hash;
    location.replace(destination.href);
  }catch(_){}
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-cart-mobile-checkout"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('lx-cart-mobile-checkout'))return;
  class LXCartMobileCheckout extends HTMLElement {
    connectedCallback(){
      if(this.cleanup)return;
      this.root=document.getElementById('MainContent');
      this.form=document.getElementById('cart');
      if(!this.root)return;
      this.sourceHTML=null;
      this.wallets=new Set();
      const sync=()=>this.sync();
      const submit=event=>{
        this.sync();
        if(this.pending&&event.target===this.form){event.preventDefault();event.stopImmediatePropagation();}
      };
      document.addEventListener('input',sync);
      document.addEventListener('change',sync);
      document.addEventListener('focusin',sync);
      document.addEventListener('focusout',sync);
      document.addEventListener('submit',submit,true);
      this.observer=new MutationObserver(sync);
      this.observer.observe(this.root,{subtree:true,childList:true,attributes:true,attributeFilter:['class']});
      this.resize=new ResizeObserver(()=>document.documentElement.style.setProperty('--lx-cart-mobile-height',Math.ceil(this.getBoundingClientRect().height)+'px'));
      this.resize.observe(this);
      this.cleanup=()=>{
        document.removeEventListener('input',sync);document.removeEventListener('change',sync);
        document.removeEventListener('focusin',sync);document.removeEventListener('focusout',sync);
        document.removeEventListener('submit',submit,true);
        this.observer.disconnect();this.resize.disconnect();
        for(const element of this.wallets)element.inert=false;
        this.wallets.clear();
        document.documentElement.style.removeProperty('--lx-cart-mobile-height');
      };
      this.sync();
    }
    sync(){
      this.form=document.getElementById('cart');
      const source=this.root.querySelector('template[data-c-opt-cart-checkout-source]');
      const active=Boolean(source && this.form && !this.root.querySelector('#main-cart-footer.is-empty'));
      this.hidden=!active;
      this.toggleAttribute('data-active',active);
      if(!active){
        this.pending=true;
        document.documentElement.style.setProperty('--lx-cart-mobile-height','0px');
        return;
      }
      if(this.sourceHTML!==source.innerHTML){
        this.sourceHTML=source.innerHTML;
        this.replaceChildren(source.content.cloneNode(true));
      }
      this.button=this.querySelector('[data-lx-cart-checkout]');
      this.status=this.querySelector('.lxcmc-status');
      const inputs=[...this.form.querySelectorAll('input[name="updates[]"]')];
      const invalid=inputs.some(input=>!input.validity.valid);
      const dirty=inputs.some(input=>input.value!==input.defaultValue);
      this.pending=invalid||dirty||Boolean(this.root.querySelector('.cart__items--disabled'));
      this.button.disabled=this.pending;
      const message=invalid?this.dataset.invalid:this.pending?this.dataset.updating:'';
      if(this.status.textContent!==message)this.status.textContent=message;
      this.status.hidden=!message;
      for(const element of this.root.querySelectorAll('.additional-checkout-buttons')){
        if(this.pending&&!element.inert){element.inert=true;this.wallets.add(element);}
        else if(!this.pending&&this.wallets.has(element)){element.inert=false;this.wallets.delete(element);}
      }
      this.toggleAttribute('data-keyboard',Boolean(document.activeElement?.matches('textarea,input:not([type="hidden"]):not([type="button"]):not([type="submit"]),select')));
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  }
  customElements.define('lx-cart-mobile-checkout',LXCartMobileCheckout);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-cd-tier-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-lx-cd-tiers]');
  const root = document.querySelector('product-info');
  if (!marker || !root) return;
  let quantityAnchor;
  let nativeQuantity;
  let scheduled = false;
  let synchronizedQuantity;
  const arrange = () => {
    scheduled = false;
    const grid = root.querySelector('[os-vd-deal-id="6ab937d5d9c307236a20ea3b"]');
    const currentQuantity = root.querySelector('[id^="Quantity-Form-"]');
    if (currentQuantity) nativeQuantity = currentQuantity;
    const input = nativeQuantity?.querySelector('input[name="quantity"][form]');
    if (!input) return;
    if (!grid) {
      nativeQuantity.classList.remove('lx-cd-quantity');
      if (quantityAnchor?.isConnected && quantityAnchor.nextElementSibling !== nativeQuantity) quantityAnchor.after(nativeQuantity);
      return;
    }
    grid.classList.add('lx-cd-tier-grid');
    if (nativeQuantity.parentElement !== grid) {
      quantityAnchor?.remove();
      quantityAnchor = document.createElement('span');
      quantityAnchor.hidden = true;
      nativeQuantity.before(quantityAnchor);
    }
    nativeQuantity.classList.add('lx-cd-quantity');
    const firstTier = grid.querySelector('.os-vd__tier');
    if (/^\s*1(?:\D|$)/.test(firstTier?.querySelector('.os-vd__tier-title')?.textContent || '')) {
      firstTier.classList.add('lx-cd-tier-base');
    }
    if (grid.firstElementChild !== nativeQuantity) grid.prepend(nativeQuantity);
    const variantId = root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const key = `${variantId}:${input.value}`;
    if (key !== synchronizedQuantity) {
      synchronizedQuantity = key;
      requestAnimationFrame(() => {
        if (!input.isConnected) return;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(arrange);
  };
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  root.addEventListener('input', schedule);
  root.addEventListener('change', schedule);
  window.addEventListener('pageshow', () => { synchronizedQuantity = undefined; schedule(); });
  arrange();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-combined-tier-quote"] && !Shopify.designMode) return;
  try {
    (() => {
  const config=document.querySelector('[data-lx-combined-config]');
  const source=document.querySelector('[data-lx-combined-pricing]');
  const root=document.querySelector('product-info');
  if(!config||!source||!root)return;
  let variants;
  try{variants=JSON.parse(source.textContent);}catch{return;}
  const money=new Intl.NumberFormat(config.dataset.locale||'en',{style:'currency',currency:config.dataset.currency});
  const quote=document.createElement('p');
  quote.className='lx-combined-quote notranslate';quote.setAttribute('translate','no');quote.setAttribute('data-lx-combined-quote','');quote.setAttribute('role','status');
  const note=document.createElement('p');note.className='lx-combined-note';
  const retry=document.createElement('button');retry.type='button';retry.className='button button--secondary';retry.textContent=config.dataset.retry;retry.hidden=true;
  let items=[],ready=false,scheduled=false,request=0,failed=false,inflight=false;
  const text=(node,value)=>{if(node.textContent!==value)node.textContent=value;};
  const rate=()=>{
    if(config.dataset.currency===config.dataset.baseCurrency)return 1;
    const current=window.Shopify?.currency;
    const value=Number(current?.rate);
    return current?.active===config.dataset.currency&&Number.isFinite(value)&&value>0?value:null;
  };
  const calculate=(variant,quantity,existing,exchange)=>{
    if(!Number.isSafeInteger(quantity)||quantity<1||!Number.isSafeInteger(existing)||existing<0||!Number.isFinite(exchange)||exchange<=0)return null;
    const tiers=variant.tiers;
    if(!Array.isArray(tiers)||!tiers.length)return null;
    const valid=tiers.every(t=>Number.isSafeInteger(Number(t.min_qty))&&Number(t.min_qty)>0&&Number.isFinite(Number(t.unit_price))&&Number(t.unit_price)>0);
    if(!valid||!Number.isSafeInteger(variant.price)||variant.price<0)return null;
    const combined=quantity+existing;
    let cents=variant.price,minimum=0;
    for(const tier of [...tiers].sort((a,b)=>Number(a.min_qty)-Number(b.min_qty))){
      if(combined>=Number(tier.min_qty)){
        cents=Math.min(variant.price,Math.round(Number(tier.unit_price)*exchange*100));
        minimum=Number(tier.min_qty);
      }
    }
    const total=cents*quantity;
    return Number.isSafeInteger(total)?{cents,total,minimum,combined}:null;
  };
  const update=()=>{
    scheduled=false;
    const grid=root.querySelector('[os-vd-deal-id="'+config.dataset.deal+'"]');
    const deal=grid?.closest('.os-vd__volume-discount-deal');
    const input=root.querySelector('input[name="quantity"][form]');
    const id=root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const variant=variants.find(v=>String(v.id)===String(id));
    const enabled=Boolean(variant?.tiers?.length&&grid);
    deal?.classList.toggle('lx-combined-ready',enabled);
    quote.hidden=!enabled;note.hidden=true;retry.hidden=true;
    quote.dataset.total='';quote.dataset.unit='';quote.dataset.baseUnit='';quote.dataset.unitLabel=config.dataset.unit;
    if(!enabled||!input)return;
    const anchor=root.querySelector('.lx-sticker-count')||grid;
    if(quote.previousElementSibling!==anchor)anchor.after(quote);
    if(note.previousElementSibling!==quote)quote.after(note);
    quote.dataset.variant=id;quote.dataset.quantity=input.value;
    const existing=items.reduce((sum,item)=>sum+(String(item.variant_id)===String(id)?Number(item.quantity):0),0);
    const value=ready&&input.validity.valid?calculate(variant,Number(input.value),existing,rate()):null;
    if(!value){
      const invalid=!input.validity.valid||!Number.isSafeInteger(Number(input.value))||Number(input.value)<1;
      text(quote,invalid?config.dataset.invalid:failed?config.dataset.error:config.dataset.pending);
      if(!invalid&&failed){if(retry.previousElementSibling!==note)note.after(retry);retry.hidden=false;}
      return;
    }
    const baseline=calculate(variant,1,0,rate());
    quote.dataset.baseUnit=baseline?String(baseline.cents):'';
    quote.dataset.total=String(value.total);quote.dataset.unit=String(value.cents);
    text(quote,`${Number(input.value).toLocaleString(config.dataset.locale||'en')} × ${money.format(value.cents/100)} ${config.dataset.unit} · ${config.dataset.total} ${money.format(value.total/100)}`);
    if(existing){note.hidden=false;text(note,config.dataset.note.replace('{existing}',String(existing)).replace('{combined}',String(value.combined)));}
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(update);}};
  const refresh=async(event)=>{
    if(event?.cartData?.items && event.cartData.currency){
      ++request;items=event.cartData.items;ready=event.cartData.currency===config.dataset.currency;failed=!ready;schedule();return;
    }
    if(inflight)return;
    const current=++request;ready=false;failed=false;inflight=true;schedule();
    const controller=new AbortController();const timeout=setTimeout(()=>controller.abort(),10000);
    try{
      const response=await fetch(config.dataset.cartUrl,{signal:controller.signal,credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
      if(!response.ok)throw Error('cart');
      const cart=await response.json();
      if(current!==request)return;
      items=cart.items||[];ready=cart.currency===config.dataset.currency;failed=!ready;
    }catch{if(current===request){ready=false;failed=true;}}
    finally{clearTimeout(timeout);inflight=false;}
    schedule();
  };
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
  root.addEventListener('input',schedule);root.addEventListener('change',schedule);
  window.addEventListener('pageshow',refresh);window.addEventListener('focus',refresh);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh();});
  if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate)subscribe(PUB_SUB_EVENTS.cartUpdate,refresh);
  retry.addEventListener('click',refresh);
  update();refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-compact-tiers"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lx-compact-tiers')) return;
  class LXCompactTiers extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.scope = this.closest('[data-lxct-scope]') || document.getElementById(`MainProduct-${this.dataset.section}`);
      if (!this.scope) return;
      this.config = JSON.parse(this.querySelector('[data-lxct-config]').textContent);
      this.rule = this.config.pricingRule || {};
      this.renderTiers();
      this.mountQuantity();
      this.buttons = Array.from(this.querySelectorAll('[data-lxct-min]'));
      this.status = this.querySelector('[data-lxct-status]');
      this.baseStatus = this.querySelector('[data-lxct-base]');
      this.initialVariant = this.config.variant;
      this.variant = this.initialVariant;
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: this.dataset.currency || 'USD'
      });
      const onChange = (event) => {
        if (event.target.matches('[name="quantity"], [name="id"]') || event.target.closest('variant-selects, variant-radios')) this.refresh();
      };
      const onClick = (event) => {
        const button = event.target.closest('[data-lxct-min]');
        if (!button || !this.contains(button) || button.disabled) return;
        const input = this.quantityInput();
        if (!input) return;
        const next = this.validQuantity(Number(button.dataset.lxctMin), input);
        if (next === null) return;
        input.value = String(next);
        input.dispatchEvent(new Event('input', {bubbles: true}));
        input.dispatchEvent(new Event('change', {bubbles: true}));
        this.refresh();
      };
      this.scope.addEventListener('input', onChange);
      this.scope.addEventListener('change', onChange);
      this.addEventListener('click', onClick);
      // The host theme can replace quantity controls after a variant change.
      this.observer = new MutationObserver((records) => {
        if (records.some(record => !this.contains(record.target) || this.quantityBlock?.contains(record.target))) this.refresh();
      });
      this.observer.observe(this.scope, {subtree: true, childList: true, attributes: true, attributeFilter: ['min','max','step','disabled']});
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribers = [PUB_SUB_EVENTS.quantityUpdate, PUB_SUB_EVENTS.variantChange].filter(Boolean).map(name => subscribe(name, () => this.refresh()));
      this.cleanup = () => {
        this.scope.removeEventListener('input', onChange);
        this.scope.removeEventListener('change', onChange);
        this.removeEventListener('click', onClick);
        this.observer.disconnect();
        this.unsubscribers?.forEach(fn => fn());
      };
      this.refresh();
    }
    disconnectedCallback() {
      if (this.cleanup) this.cleanup();
      if (this.quantityOrigin?.isConnected && this.quantityBlock) {
        this.quantityBlock.classList.remove('lxct-quantity-cell');
        this.quantityOrigin.replaceWith(this.quantityBlock);
      }
      this.cleanup = null;
    }
    mountQuantity() {
      const block = document.getElementById(`Quantity-Form-${this.dataset.section}`);
      const grid = this.querySelector('.lxct-grid');
      if (!block || !grid || this.contains(block)) return;
      this.quantityOrigin = document.createComment('');
      block.before(this.quantityOrigin);
      this.quantityBlock = block;
      block.classList.add('lxct-quantity-cell');
      grid.prepend(block);
    }
    quantityInput() {
      return this.scope.querySelector(`#Quantity-${CSS.escape(this.dataset.section)}`) || this.scope.querySelector('input[name="quantity"]');
    }
    validQuantity(threshold, input) {
      const min = Math.max(1, Number(input.min) || 1);
      const step = Math.max(1, Number(input.step) || 1);
      const max = input.max === '' ? Infinity : Number(input.max);
      const amount = min + Math.ceil((Math.max(min, threshold) - min) / step) * step;
      return input.disabled || amount > max ? null : amount;
    }
    selectedVariant() {
      const picker = this.scope.querySelector('variant-selects, variant-radios');
      // Reuse the theme's loaded variant data instead of fetching the catalog again.
      if (picker && typeof picker.getVariantData === 'function') {
        if (!picker.currentVariant && picker.options) return null;
        if (picker.currentVariant) return picker.currentVariant;
      }
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      const input = form?.querySelector('[name="id"]') || this.scope.querySelector('[name="id"]');
      const id = input?.value || String(this.initialVariant.id);
      let variants = this.config.variants;
      if (!variants && picker) {
        if (typeof picker.getVariantData === 'function') {
          try { variants = picker.getVariantData(); } catch (_) { variants = []; }
        }
        else {
          const data = picker.querySelector('[type="application/json"]');
          if (data) { try { variants = JSON.parse(data.textContent); } catch (_) { variants = []; } }
        }
      }
      return variants?.find(v => String(v.id) === id) || (id === String(this.initialVariant.id) ? this.initialVariant : null);
    }
    renderTiers() {
      const grid = this.querySelector('.lxct-grid');
      const sample = grid.querySelector('[data-lxct-min]');
      if (!sample) return;
      const template = sample.cloneNode(true);
      grid.querySelectorAll('[data-lxct-min]').forEach(button => button.remove());
      for (const [minimum] of this.rule.discounts || []) {
        const button = template.cloneNode(true);
        button.dataset.lxctMin = String(minimum);
        button.querySelector('.lxct-quantity').textContent = `${minimum}+`;
        if (this.rule.unit === 'pair') button.querySelector('.lxct-unit').textContent = this.config.perPair;
        grid.append(button);
      }
    }
    unitTarget(reference, quantity, discount) {
      if (!Number.isSafeInteger(reference) || !Number.isSafeInteger(quantity) || quantity < 1) return null;
      const numerator = reference * quantity * (100 - discount);
      if (!Number.isSafeInteger(numerator)) return null;
      const total = Math.floor((numerator + 50) / 100);
      return Math.ceil(total / quantity) - this.rule.reductionCents;
    }
    priceTable() {
      const id = String(this.variant?.id);
      if (this.rule.heldVariantIds?.includes(id)) return null;
      const reference = this.rule.referenceBasesCents?.[id];
      if (!Number.isSafeInteger(reference) || reference <= this.rule.reductionCents) return null;
      const tiers = (this.rule.discounts || []).map(([minimum, discount]) => [minimum, this.unitTarget(reference, minimum, discount), discount]);
      if (!tiers.length || tiers.some(row => !Number.isSafeInteger(row[1]) || row[1] <= 1)) return null;
      return {baseCents: reference - this.rule.reductionCents, referenceBaseCents: reference, tiers};
    }
    refresh() {
      const input = this.quantityInput();
      this.variant = this.selectedVariant();
      const table = this.priceTable();
      const supportedCurrency = this.dataset.currency === 'USD';
      const usable = Boolean(input && this.variant?.available && table && supportedCurrency);
      const quantity = Number(input?.value) || 0;
      const validInput = Boolean(input && Number.isSafeInteger(quantity) && quantity > 0 && this.validQuantity(quantity, input) === quantity);
      let active = null;
      for (const button of this.buttons) {
        const minimum = Number(button.dataset.lxctMin);
        const tier = table?.tiers.find(row => row[0] === minimum);
        button.disabled = !usable || !tier || this.validQuantity(minimum, input) === null;
        if (usable && tier) {
          button.querySelector('[data-lxct-price]').textContent = this.format.format(tier[1] / 100);
          const percent = Math.max(0, Math.round((1 - tier[1] / table.baseCents) * 100));
          button.querySelector('.lxct-discount').textContent = this.config.discountLabel.replace('{percent}', String(percent));
        } else {
          button.querySelector('[data-lxct-price]').textContent = '—';
          button.querySelector('.lxct-discount').textContent = '—';
        }
        if (usable && validInput && tier && minimum <= quantity && (!active || minimum > Number(active.dataset.lxctMin))) active = button;
      }
      for (const button of this.buttons) button.setAttribute('aria-pressed', String(button === active));
      const tier = table?.tiers.filter(row => row[0] <= quantity).at(-1);
      const target = usable && validInput ? this.unitTarget(table.referenceBaseCents, quantity, tier?.[2] || 0) : null;
      const pair = this.rule.unit === 'pair';
      const held = this.rule.heldVariantIds?.includes(String(this.variant?.id));
      const message = !supportedCurrency ? this.config.currencyPending : !this.variant?.available || !input ? this.config.unavailable : held ? this.config.quoteRequired : !table ? this.config.unpriced : !validInput ? this.config.unavailable : target !== null ? (pair ? this.config.pairSelected : this.config.selected).replace('{quantity}', String(quantity)).replace('{price}', this.format.format(target / 100)) : this.config.hint;
      if (this.status.textContent !== message) this.status.textContent = message;
      if (this.baseStatus) {
        const label = pair ? this.config.pairBaseLabel : this.config.baseLabel;
        const maximum = (this.rule.discounts?.[0]?.[0] || 2) - 1;
        const baseText = usable ? label.replace('{maximum}', String(maximum)).replace('{price}', this.format.format(table.baseCents / 100)) : '';
        if (this.baseStatus.textContent !== baseText) this.baseStatus.textContent = baseText;
      }
      const total = this.querySelector('[data-lxct-total]');
      if (total) {
        const text = target !== null && target > 1 ? this.config.totalLabel.replace('{price}', this.format.format(target * quantity / 100)) : '';
        if (total.textContent !== text) total.textContent = text;
      }
    }
  }
  customElements.define('lx-compact-tiers', LXCompactTiers);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-keychain-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeGuide() {
    const guide = document.querySelector('.lx-keychain-guide');
    if (!guide || guide.dataset.navigationReady) return;
    guide.dataset.navigationReady = 'true';
    const nativeDate = guide.querySelector('input[name="contact[needed_by]"]');
    if (nativeDate) {
      const control = document.createElement('div');
      control.className = 'lx-quote-date-control';
      nativeDate.before(control);
      control.append(nativeDate);
      const dateText = document.createElement('input');
      dateText.type = 'text';
      dateText.id = nativeDate.id + '-text';
      dateText.placeholder = 'YYYY-MM-DD';
      dateText.autocomplete = 'off';
      dateText.maxLength = 10;
      dateText.value = nativeDate.value;
      dateText.setAttribute('aria-label', nativeDate.labels[0]?.textContent.trim() || 'Needed-by date (optional)');
      for (const label of [...nativeDate.labels]) label.htmlFor = dateText.id;
      nativeDate.tabIndex = -1;
      nativeDate.setAttribute('aria-hidden', 'true');
      control.append(dateText);
      const fromText = () => {
        const value = dateText.value.trim();
        nativeDate.value = /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : '';
        const valid = !value || (nativeDate.value === value && nativeDate.validity.valid);
        dateText.setCustomValidity(valid ? '' : 'Enter a valid date in YYYY-MM-DD format.');
        dateText.setAttribute('aria-invalid', String(!valid));
      };
      const fromPicker = () => {
        dateText.value = nativeDate.value;
        dateText.setCustomValidity('');
        dateText.setAttribute('aria-invalid', 'false');
      };
      dateText.addEventListener('input', fromText);
      nativeDate.addEventListener('input', fromPicker);
      nativeDate.addEventListener('change', fromPicker);
      nativeDate.form?.addEventListener('reset', () => requestAnimationFrame(fromPicker));
      if (typeof nativeDate.showPicker === 'function') {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', 'Choose date');
        button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><rect x="4" y="5" width="16" height="16" rx="2"/><path d="M8 3v4m8-4v4M4 10h16"/></svg>';
        button.addEventListener('click', () => {
          try { nativeDate.showPicker(); } catch { dateText.focus(); }
        });
        control.append(button);
      }
    }

    const nav = guide.querySelector('.lx-guide-nav');
    const header = document.querySelector('.lx-ref-header-section');
    const links = [...nav.querySelectorAll('a')];
    const sections = links.map(link => document.getElementById(link.hash.slice(1)));
    let scheduled = false;
    const refresh = () => {
      scheduled = false;
      if (!guide.isConnected) return;
      if (header) guide.style.setProperty('--lx-guide-header-height', `${header.offsetHeight}px`);
      guide.style.setProperty('--lx-guide-nav-height', `${nav.offsetHeight}px`);
      const edge = nav.getBoundingClientRect().bottom + 28;
      let active = sections[0];
      for (const section of sections) if (section.getBoundingClientRect().top <= edge) active = section;
      for (const link of links) {
        if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
    const openAnchor = () => {
      const target = document.getElementById(location.hash.slice(1));
      if (!target || !guide.contains(target)) return;
      for (let parent = target; parent && parent !== guide; parent = parent.parentElement) {
        if (parent.matches('details')) parent.open = true;
      }
      if (target.id === 'LXBulkOrder') target.querySelector('details').open = true;
      refresh();
      target.scrollIntoView({block: 'start'});
      schedule();
    };
    guide.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#LX"]');
      if (link && link.hash === location.hash) requestAnimationFrame(openAnchor);
    });
    window.addEventListener('hashchange', openAnchor);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    guide.addEventListener('toggle', schedule, true);
    const observer = new ResizeObserver(schedule);
    if (header) observer.observe(header);
    observer.observe(nav);
    refresh();
    openAnchor();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(guide)) return;
      window.removeEventListener('hashchange', openAnchor);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      observer.disconnect();
    }, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeGuide, {once: true});
  else initializeGuide();
  document.addEventListener('shopify:section:load', initializeGuide);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-mobile-customization"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lx-mobile-customization')) return;
  class LXMobileCustomization extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.details = this.querySelector('details');
      this.content = this.querySelector('[data-lx-app-content]');
      this.status = this.querySelector('[data-lx-customization-status]');
      this.collapseButton = this.querySelector('.lxmc-collapse');
      this.copy = JSON.parse(this.querySelector('[data-lx-customization-config]').textContent);
      this.mobile = window.matchMedia('(max-width:749px)');
      this.scope = document.getElementById(`MainProduct-${this.dataset.section}`);
      this.touched = false;
      this.initialized = false;
      const onInteraction = () => { this.touched = true; };
      const onToggle = () => this.update();
      const onValidation = () => this.reveal();
      const onMedia = () => this.update();
      const onCollapse = () => {
        if (this.collapseButton.disabled) return;
        this.touched = true;
        this.details.open = false;
        const summary = this.details.querySelector('summary');
        summary.focus({preventScroll:true});
        const top = summary.getBoundingClientRect().top;
        if (top < 120 || top > window.innerHeight - 100) summary.scrollIntoView({block:'center',behavior:'auto'});
      };
      const onHash = () => {
        if (window.location.hash === `#${this.details.id}`) this.reveal();
      };
      const onLink = (event) => {
        const link = event.target.closest('a[href]');
        if (link?.getAttribute('href') === `#${this.details.id}`) this.reveal();
      };
      this.addEventListener('pointerdown', onInteraction);
      this.addEventListener('keydown', onInteraction);
      this.addEventListener('input', onInteraction);
      this.details.addEventListener('toggle', onToggle);
      this.collapseButton.addEventListener('click', onCollapse);
      this.addEventListener('invalid', onValidation, true);
      this.scope?.addEventListener('submit', onValidation, true);
      window.addEventListener('builder-validate', onValidation, true);
      window.addEventListener('hashchange', onHash);
      document.addEventListener('click', onLink);
      this.mobile.addEventListener('change', onMedia);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.content, {subtree:true, childList:true, attributes:true, attributeFilter:['class','aria-busy','aria-invalid']});

      // The app renders upload help into a body portal. Only patch that help text,
      // without changing its settings, upload input, or pricing state.
      const normalizeUploadTip = tip => {
        if (!this.isConnected || !this.querySelector('[id$="image-upload-list"]')) return;
        const text = tip.textContent || '';
        if (!/File Format/i.test(text) || !/(?:lexianggift@gmail\.com|service@lxacrylic\.com)/i.test(text)) return;
        const walker = document.createTreeWalker(tip, NodeFilter.SHOW_TEXT);
        let node;
        while ((node = walker.nextNode())) {
          const next = node.nodeValue.replace(/lexianggift@gmail\.com/gi, 'service@lxacrylic.com');
          if (next !== node.nodeValue) node.nodeValue = next;
        }
        tip.querySelectorAll('a[href^="mailto:"]').forEach(link => {
          if (/lexianggift@gmail\.com/i.test(link.getAttribute('href'))) link.setAttribute('href', 'mailto:service@lxacrylic.com');
        });
        tip.classList.add('c-opt-upload-tip');
      };
      const inspectUploadTips = node => {
        const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
        if (!element) return;
        const tip = element.closest('.ant-popover-inner-content');
        if (tip) normalizeUploadTip(tip);
        element.querySelectorAll('.ant-popover-inner-content').forEach(normalizeUploadTip);
      };
      this.uploadTipObserver = new MutationObserver(records => {
        records.forEach(record => {
          if (record.type === 'characterData') inspectUploadTips(record.target);
          else record.addedNodes.forEach(inspectUploadTips);
        });
      });
      this.uploadTipObserver.observe(document.body, {subtree:true,childList:true,characterData:true});
      document.querySelectorAll('.ant-popover-inner-content').forEach(normalizeUploadTip);

      this.cleanup = () => {
        this.uploadTipObserver.disconnect();
        this.removeEventListener('pointerdown', onInteraction);
        this.removeEventListener('keydown', onInteraction);
        this.removeEventListener('input', onInteraction);
        this.details.removeEventListener('toggle', onToggle);
        this.collapseButton.removeEventListener('click', onCollapse);
        this.removeEventListener('invalid', onValidation, true);
        this.scope?.removeEventListener('submit', onValidation, true);
        window.removeEventListener('builder-validate', onValidation, true);
        window.removeEventListener('hashchange', onHash);
        document.removeEventListener('click', onLink);
        this.mobile.removeEventListener('change', onMedia);
        this.observer.disconnect();
        cancelAnimationFrame(this.frame);
      };
      onHash();
      this.update();
    }
    reveal() {
      this.touched = true;
      this.details.open = true;
    }
    update() {
      if (this.hasAttribute("data-lx-inline-options")) {
        this.details.open = true;
        return;
      }
      const accessory = this.content.querySelector('[data-lx-accessory-field]') || Array.from(this.content.querySelectorAll('[id$="image-swatch"]')).find(field => /accessor/i.test(field.querySelector('.form__label')?.textContent || ''));
      if (accessory && !this.hasAttribute('data-lx-accessories-only')) {
        accessory.setAttribute('data-lx-accessory-field', '');
        const body = this.querySelector('.lxmc-body');
        this.details.after(body);
        this.setAttribute('data-lx-accessories-only', '');
        this.details.querySelector('strong').textContent = this.copy.accessoriesHeading;
        this.details.querySelector('summary').setAttribute('aria-controls', accessory.id);
        this.querySelector('.lxmc-intro').textContent = this.copy.accessoriesIntro;
      }
      const uploading = this.content.querySelector('.image-upload .ant-spin-spinning, .image-upload [aria-busy="true"]');
      const error = this.content.querySelector('.required-error:not(.lx-artwork-empty-error), [aria-invalid="true"]');
      if (uploading || error) this.details.open = true;
      this.collapseButton.disabled = Boolean(uploading || error);
      const copy = uploading ? this.copy.uploading : error ? this.copy.error : this.details.open ? this.copy.expanded : this.copy.closed;
      if (this.status.textContent !== copy) this.status.textContent = copy;
      // Wait until the App has mounted real controls before hiding its panel.
      if (!this.initialized && this.content.querySelector('input:not([type="hidden"]),select,textarea,button')) {
        this.initialized = true;
        this.frame = requestAnimationFrame(() => {
          if (this.isConnected && this.dataset.designMode !== 'true' && !this.touched && !uploading && !error && !this.contains(document.activeElement)) {
            this.details.open = false;
          }
        });
      }
    }
    disconnectedCallback() { this.cleanup?.(); this.cleanup = null; }
  }
  customElements.define('lx-mobile-customization', LXMobileCustomization);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-mobile-purchase"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('lx-mobile-purchase')) return;
  class LXMobilePurchase extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      this.root=document.querySelector('.main-product product-info');
      if (!this.root) return;
      this.section=this.root.dataset.section;
      this.copy=JSON.parse(this.querySelector('[data-lxmp-config]').textContent);
      this.price=this.querySelector('[data-lxmp-price]');
      this.quantity=this.querySelector('[data-lxmp-quantity]');
      this.saving=this.querySelector('[data-lxmp-saving]');
      this.details=this.querySelector('.c-opt-purchase-details');
      this.action=this.querySelector('.lxmp-action');
      this.format=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:this.dataset.currency||'USD',currencyDisplay:'code'});
      this.desktop=document.querySelector('[data-lx-desktop-purchase]');
      this.desktopPrice=this.desktop?.querySelector('[data-lxdp-total]');
      this.desktopAction=this.desktop?.querySelector('.lxdp-action');
      this.desktopSaving=this.desktop?.querySelector('[data-lxdp-saving]');
      this.desktopUnit=this.desktop?.querySelector('[data-lxdp-unit]');
      this.desktopFormat=this.format;
      const desktopAdd=()=>this.action.click();
      this.desktopAction?.addEventListener('click',desktopAdd);
      const refresh=()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.update());};
      const focus=()=>this.toggleAttribute('data-keyboard',Boolean(document.activeElement?.matches('textarea,input:not([type="hidden"]):not([type="checkbox"]):not([type="radio"]):not([type="button"]):not([type="submit"]),select')));
      const add=()=>this.addSelected();
      this.root.addEventListener('input',refresh);this.root.addEventListener('change',refresh);
      this.action.addEventListener('click',add);
      document.addEventListener('focusin',focus);document.addEventListener('focusout',refresh);
      this.observer=new MutationObserver(refresh);
      this.observer.observe(this.root,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-lx-cart-pending','data-lx-restoring','data-lx-restore-failed','min','max','step','disabled','value','class','aria-disabled','aria-busy','data-total','data-base-unit','data-unit','data-unit-label','data-quantity','data-variant','hidden']});
      if(!this.hasAttribute('data-desktop-only')){this.resize=new ResizeObserver(()=>document.documentElement.style.setProperty('--lx-mobile-purchase-height',this.getBoundingClientRect().height+'px'));this.resize.observe(this);}
      this.refreshFocus=focus;
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribers=[PUB_SUB_EVENTS.quantityUpdate,PUB_SUB_EVENTS.variantChange,PUB_SUB_EVENTS.cartUpdate].filter(Boolean).map(name=>subscribe(name,refresh));
      this.cleanup=()=>{
        this.root.removeEventListener('input',refresh);this.root.removeEventListener('change',refresh);this.action.removeEventListener('click',add);
        document.removeEventListener('focusin',focus);document.removeEventListener('focusout',refresh);
        this.observer.disconnect();this.resize?.disconnect();
        if(this.details){this.details.hidden=true;this.append(this.details);}
        this.desktopAction?.removeEventListener('click',desktopAdd);
        this.desktop?.closest('.sticky-atc-bar')?.removeAttribute('data-lx-desktop-ready');this.unsubscribers?.forEach(fn=>fn());
        cancelAnimationFrame(this.frame);clearTimeout(this.release);
        if(!this.hasAttribute('data-desktop-only'))document.documentElement.style.removeProperty('--lx-mobile-purchase-height');this.removeAttribute('data-ready');
      };
      this.update();this.setAttribute('data-ready','');
    }
    quantityInput(){return document.getElementById('Quantity-'+this.section);}
    form(){return document.getElementById('product-form-'+this.section);}
    originalButton(){return this.form()?.querySelector('button[name="add"],button[type="submit"]');}
    validQuantity(input){return Boolean(input&&!input.disabled&&input.value.trim()!==''&&Number(input.value)>0&&Number.isInteger(Number(input.value))&&input.validity.valid);}
    variant(){
      const picker=this.root.querySelector('variant-selects,variant-radios');
      if(picker?.options&&!picker.currentVariant)return null;
      if(picker?.currentVariant)return picker.currentVariant;
      const id=this.form()?.querySelector('[name="id"]')?.value;
      const json=picker?.querySelector('[type="application/json"]');
      try{
        const variants=typeof picker?.getVariantData==='function'?picker.getVariantData():this.cachedVariants(json);
        return variants.find(v=>String(v.id)===String(id||this.copy.initialVariant.id))||null;
      }catch(_){return null;}
    }
    cachedVariants(source){
      const text=source?.textContent;
      if(this.variantSource!==text||!this.variantCache){
        this.variantSource=text;
        this.variantCache=text?JSON.parse(text):[this.copy.initialVariant];
      }
      return this.variantCache;
    }
    setText(node,value){if(node.textContent!==value)node.textContent=value;}
    parseMoney(text){
      if(window.LXPurchaseState)return window.LXPurchaseState.parseMoney(text);
      let value=String(text).replace(/[٠-٩]/g,c=>String(c.charCodeAt(0)-1632)).replace(/[۰-۹]/g,c=>String(c.charCodeAt(0)-1776)).replace(/٫/g,'.').replace(/٬/g,',').replace(/[^0-9.,-]/g,'');
      if(!/[0-9]/.test(value))return null;
      const decimals=Math.max(2,this.format.resolvedOptions().maximumFractionDigits);
      const separator=Math.max(value.lastIndexOf('.'),value.lastIndexOf(','));
      if(decimals>0&&separator>=0&&value.length-separator-1>0&&value.length-separator-1<=decimals)value=value.slice(0,separator).replace(/[.,]/g,'')+'.'+value.slice(separator+1);
      else value=value.replace(/[.,]/g,'');
      const amount=Number(value);return Number.isFinite(amount)&&amount>=0?Math.round(amount*100):null;
    }
    displayedUnit(variant){
      const container=this.root.querySelector('[id="price-'+this.section+'"]');if(!container)return null;
      const sale=container.querySelector('.price__sale');
      const selector=sale&&getComputedStyle(sale).display!=='none'?'.price-item--sale':'.price__regular .price-item--regular';
      const element=container.querySelector(selector);
      const value=element?this.parseMoney(element.textContent):null;
      return value!==null?value:this.root.querySelector('#shopaw-container-block,#shopaw-container')?null:Number(variant.price);
    }
    displayedPricing(variant,input){
      if(window.LXPurchaseReadiness&&!window.LXPurchaseReadiness.ready(this.root))return {unit:null,total:null};
      const stickerQuote=this.root.querySelector('[data-lx-sticker-quote], [data-lx-combined-quote]');
      if(stickerQuote&&!stickerQuote.hidden&&stickerQuote.dataset.variant===String(variant.id)){
        const raw=stickerQuote.dataset.quantity===String(input.value)?stickerQuote.dataset.total:'';
        const total=raw!==''?Number(raw):null;
        return {total,unit:total===null?null:total/Number(input.value)};
      }
      const grids=[...this.root.querySelectorAll('[os-vd-deal-id]')].filter(node=>
        node.querySelector(':scope > .os-vd__tier')&&!node.closest('[hidden]')&&node.getClientRects().length);
      if(grids.length){
        if(grids.length!==1)return {total:null,unit:null,base:null};
        const deal=grids[0].closest('.os-vd__volume-discount-deal');
        const price=deal?.querySelector('.os-vd__footer-total > span:not(.os-vd__footer-total-original)');
        const total=price?this.parseMoney(price.textContent):null;
        // Shopify's current variant price is the undiscounted merchandise baseline.
        // One Stop remains the sole owner of the daily tier total. Do not apply a promotion here.
        const variantBase=Number(variant.price);
        const base=Number.isSafeInteger(variantBase)&&variantBase>0?variantBase:null;
        return {total,unit:total===null?null:total/Number(input.value),base};
      }
      // A configured app deal must publish its own total before any numeric quote appears.
      // The Shopify base price is not a fallback for a loading tier-pricing widget.
      if(this.root.querySelector('ssl-os-vd[data-has-applicable-deal="true"]'))return {unit:null,total:null};
      const unit=this.displayedUnit(variant);
      return {unit,total:unit===null?null:unit*Number(input.value)};
    }
    selectedPack(variant){
      const index=this.copy.packOptionIndex;
      return Number.isInteger(index)&&index>=0?String(variant?.options?.[index]||''):'';
    }
    desktopSummary(variant,input,pricing){
      const empty={total:null,unit:null,saved:0,label:this.copy.perPiece};
      if(!variant?.available||!this.validQuantity(input))return empty;
      const quantity=Number(input.value);
      if(!Number.isSafeInteger(quantity))return empty;
      const quotes=[...this.root.querySelectorAll('[data-lx-sticker-quote], [data-lx-combined-quote]')].filter(node=>!node.hidden);
      let total=pricing.total,base=pricing.base??null,label=this.copy.perPiece;
      const pack=this.selectedPack(variant);
      if(pack)label=this.copy.packUnit.replace('{pack}',pack);
      if(quotes.length){
        const quote=quotes.find(node=>node.dataset.variant===String(variant.id)&&node.dataset.quantity===String(input.value));
        if(!quote||quote.dataset.total==='')return empty;
        total=Number(quote.dataset.total);
        base=quote.dataset.baseUnit?Number(quote.dataset.baseUnit):null;
        label=quote.dataset.unitLabel||this.root.querySelector('[data-lx-sticker-tiers]')?.dataset.unitLabel||label;
      }else if(this.root.querySelector('[data-lx-combined-config], [data-lx-cd-quote-config]')){
        // Wait for the authoritative quantity quote rather than using a previous variant price.
        return empty;
      }
      if(!Number.isSafeInteger(total)||total<0)return empty;
      const original=Number.isSafeInteger(base)&&base>0?base*quantity:null;
      const saved=Number.isSafeInteger(original)&&original>total?original-total:0;
      return {total,unit:total/quantity,saved,label};
    }
    addSelected(){
      if(this.root.matches('[data-lx-cart-pending],[data-lx-restoring],[data-lx-restore-failed]'))return;
      if(window.LXPurchaseReadiness&&!window.LXPurchaseReadiness.ready(this.root))return;
      const input=this.quantityInput(),variant=this.variant(),button=this.originalButton(),form=this.form();
      this.root.querySelector('lx-mobile-customization')?.reveal?.();
      if(!this.validQuantity(input)){input?.scrollIntoView({block:'center'});input?.focus({preventScroll:true});input?.reportValidity();return;}
      if(!variant?.available||!button||button.disabled||button.getAttribute('aria-disabled')==='true'){this.root.querySelector('variant-selects,variant-radios')?.scrollIntoView({block:'center'});return;}
      if(form&&!form.checkValidity()){form.reportValidity();return;}
      button.click();this.update();
    }
    update(){
      const variant=this.variant(),input=this.quantityInput(),button=this.originalButton(),valid=this.validQuantity(input);
      // Keep pricing disclosures beside the original form, without changing its submit path.
      if(this.details&&button&&!this.hasAttribute('data-desktop-only')){
        if(this.details.nextElementSibling!==button)button.before(this.details);
        if(this.details.hidden)this.details.hidden=false;
      }
      const pricing=variant?.available&&valid?this.displayedPricing(variant,input):{unit:null,total:null};
      const summary=this.desktopSummary(variant,input,pricing);
      const {unit,total}=summary;
      const inline=this.root.querySelector('[data-c-opt-summary]');
      if(inline){
        this.setText(inline.querySelector('[data-c-opt-total]'),!variant?.available?this.copy.unavailable:total===null?this.copy.pending:this.format.format(total/100));
        this.setText(inline.querySelector('[data-c-opt-unit]'),unit===null?'':this.format.format(unit/100)+' '+summary.label);
      }
      const missingAccessory=[...this.root.querySelectorAll('[data-lx-app-content] [id$="image-swatch"]')].some(field=>field.querySelector('.custom-required')&&!field.querySelector('.c-active-option'));
      const initializing=Boolean(window.LXPurchaseReadiness&&!window.LXPurchaseReadiness.ready(this.root));
      const quotePending=Boolean(variant?.available&&valid&&total===null);
      const busy=this.root.matches('[data-lx-cart-pending],[data-lx-restoring],[data-lx-restore-failed]')||button?.classList.contains('loading')||this.root.querySelector('.image-upload .ant-spin-spinning,.image-upload [aria-busy="true"]');
      this.setText(this.price,!variant?.available?this.copy.unavailable:total===null?this.copy.pending:this.format.format(total/100));
      let quantityText=valid?({one:this.copy.quantityOne,few:this.copy.quantityFew,many:this.copy.quantityMany,other:this.copy.quantity}[new Intl.PluralRules(document.documentElement.lang||'en').select(Number(input.value))]||this.copy.quantity).replace('{quantity}',input.value)+(unit===null?'':' · '+this.copy.unit.replace('{price}',this.format.format(unit/100))):this.copy.quantityInvalid;
      const pack=this.selectedPack(variant);
      if(valid&&pack)quantityText=this.copy.packQuantity.replace('{quantity}',input.value).replace('{pack}',pack)+(unit===null?'':' · '+this.format.format(unit/100)+' '+this.copy.packUnit.replace('{pack}',pack));
      const stickerMarker=document.querySelector('[data-lx-sticker-tiers]');
      if(valid&&stickerMarker)quantityText=`${input.value} ${stickerMarker.dataset.setLabel}`+(unit===null?'':` · ${this.format.format(unit/100)} ${stickerMarker.dataset.unitLabel}`);
      this.setText(this.quantity,quantityText);
      const savingText=summary.saved>0?this.copy.save.replace('{amount}',this.format.format(summary.saved/100)):'';
      this.setText(this.saving,savingText);this.saving.hidden=!savingText;
      this.action.toggleAttribute('disabled',Boolean(busy||initializing||quotePending||!button));
      this.action.setAttribute('aria-busy',String(Boolean(busy||initializing||quotePending)));
      this.setText(this.action,busy?this.copy.busy:variant?.available&&!missingAccessory?this.copy.add:this.copy.choose);
      if(this.desktopPrice&&this.desktopAction){
        const desktop=summary;
        const amount=desktop.total!==null?this.desktopFormat.format(desktop.total/100):this.copy.pending;
        this.setText(this.desktopPrice,!variant?.available?this.copy.unavailable:amount);
        this.desktopPrice.title=desktop.total!==null?this.format.format(desktop.total/100):amount;
        if(this.desktopSaving){
          const savingText=desktop.saved>0?this.copy.save.replace('{amount}',this.desktopFormat.format(desktop.saved/100)):'';
          this.setText(this.desktopSaving,savingText);this.desktopSaving.hidden=!savingText;
        }
        if(this.desktopUnit){
          const unitText=desktop.unit!==null?`${this.desktopFormat.format(desktop.unit/100)} ${desktop.label}`:'';
          this.setText(this.desktopUnit,unitText);this.desktopUnit.hidden=!unitText;
        }
        this.desktopAction.disabled=Boolean(busy||initializing||quotePending||!button);
        this.desktopAction.setAttribute('aria-busy',String(Boolean(busy||initializing||quotePending)));
        const addLabel=button?.textContent.trim()||this.copy.add;
        this.setText(this.desktopAction,busy?this.copy.busy:variant?.available?addLabel:this.copy.choose);
        this.desktop.closest('.sticky-atc-bar')?.setAttribute('data-lx-desktop-ready','');
      }
      window.LXPurchaseState?.publish(this.root,{
        product:String(this.dataset.product),variant:variant?String(variant.id):null,quantity:valid?Number(input.value):null,
        currency:this.dataset.currency,quoteStatus:initializing||quotePending?'pending':variant?.available&&valid?'ready':'invalid',
        total:total,unit:unit,accessoryComplete:!missingAccessory,
        uploadStatus:this.root.querySelector('.image-upload .ant-spin-spinning,.image-upload [aria-busy="true"]')?'uploading':'idle',
        purchasePending:this.root.hasAttribute('data-lx-cart-pending')
      });
      this.refreshFocus?.();
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  }
  customElements.define('lx-mobile-purchase',LXMobilePurchase);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-one-stop-test-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  if(window.LXTierLayout){window.LXTierLayout.refresh();return;}
  const instances=new Map();
  const initialize=root=>{
  if(instances.has(root))return;
  const marker = document.querySelector('[data-lx-tier-test]');
  if (!marker) return;
  // These products have existing pack/cart-aware quantity controllers.
  if (document.querySelector('[data-lx-cd-tiers], [data-lx-shaker-tiers], [data-lx-sticker-tiers]')) return;
  if (!root) return;
  let nativeQuantity = root.querySelector('[id^="Quantity-Form-"]');
  let scheduled = false;
  let quantityAnchor;
  let synchronizedQuantity;
  const arrange = () => {
    scheduled = false;
    const grids = [...root.querySelectorAll('[os-vd-deal-id]')].filter(node =>
      node.querySelector(':scope > .os-vd__tier') && !node.closest('[hidden]') && node.getClientRects().length);
    // An ambiguous pair of offers must retain the app's own layout.
    const grid = grids.length === 1 ? grids[0] : null;
    const selectedId = root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const active = !!grid && !!selectedId;
    root.classList.toggle('lx-live-tier-active', active);
    root.querySelectorAll('#shopaw-container-block button, #shopaw-container button').forEach(button => {
      const label = button.textContent.trim().toUpperCase();
      if (label.startsWith('ADD TO CART') || label.startsWith('BUY')) button.classList.toggle('lx-tier-duplicate-buy', active);
    });
    const currentQuantity = root.querySelector('[id^="Quantity-Form-"]');
    if (currentQuantity) nativeQuantity = currentQuantity;
    if (!active) {
      if (nativeQuantity?.classList.contains('lx-test-tier-quantity')) {
        nativeQuantity.classList.remove('lx-test-tier-quantity');
        if (quantityAnchor?.isConnected) quantityAnchor.after(nativeQuantity);
      }
      return;
    }
    if (!nativeQuantity || !nativeQuantity.querySelector('input[name="quantity"][form]')) return;
    const quantityInput = nativeQuantity.querySelector('input[name="quantity"][form]');
    const quantityKey = `${selectedId}:${quantityInput.value}`;
    if (quantityKey !== synchronizedQuantity) {
      synchronizedQuantity = quantityKey;
      requestAnimationFrame(() => {
        if (!quantityInput.isConnected) return;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    if (nativeQuantity.parentElement !== grid) {
      if (quantityAnchor?.isConnected) quantityAnchor.remove();
      quantityAnchor = document.createElement('span');
      quantityAnchor.hidden = true;
      nativeQuantity.before(quantityAnchor);
    }
    if (marker.dataset.lxTierNote) {
      const footer = grid.closest('.os-vd__volume-discount-deal')?.querySelector('.os-vd__footer-text');
      if (footer && footer.textContent !== marker.dataset.lxTierNote) footer.textContent = marker.dataset.lxTierNote;
    }
    grid.classList.add('lx-test-tier-grid','c-opt-tier-grid');
    nativeQuantity.classList.add('lx-test-tier-quantity');
    const firstTier = grid.querySelector('.os-vd__tier');
    if (firstTier && /^\s*1(?:\D|$)/.test(firstTier.querySelector('.os-vd__tier-title')?.textContent || '')) {
      firstTier.classList.add('lx-test-tier-base');
    }
    if (nativeQuantity.parentElement !== grid || grid.firstElementChild !== nativeQuantity) {
      grid.prepend(nativeQuantity);
    }
  };
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(arrange);}};
  const observer=new MutationObserver(schedule);
  observer.observe(root,{childList:true,subtree:true});
  root.addEventListener('input',schedule);root.addEventListener('change',schedule);
  const cleanup=()=>{observer.disconnect();root.removeEventListener('input',schedule);root.removeEventListener('change',schedule);instances.delete(root);};
  instances.set(root,{cleanup,schedule});arrange();
  };
  const refresh=()=>{for(const[root,instance]of instances)if(!root.isConnected)instance.cleanup();document.querySelectorAll('.main-product product-info').forEach(initialize);for(const instance of instances.values())instance.schedule();};
  window.LXTierLayout={refresh};
  document.addEventListener('shopify:section:load',refresh);
  document.addEventListener('shopify:section:unload',event=>{for(const[root,instance]of instances)if(event.target.contains(root))instance.cleanup();});
  window.addEventListener('pageshow',refresh);refresh();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-optional-artwork"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lx-optional-artwork')) {
    customElements.define('lx-optional-artwork', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('product-info');
        this.noteTemplate = this.querySelector('template');
        if (!this.root || !this.noteTemplate || this.observer) return;
        this.queueUpdate = () => {
          if (this.updateQueued) return;
          this.updateQueued = true;
          queueMicrotask(() => {
            this.updateQueued = false;
            if (this.isConnected) this.updateFields();
          });
        };
        this.observer = new MutationObserver(this.queueUpdate);
        this.observer.observe(this.root, {
          childList: true,
          subtree: true,
          characterData: true,
          attributes: true,
          attributeFilter: ['class', 'required', 'aria-required', 'aria-busy']
        });
        window.addEventListener('builder-validate', this.queueUpdate);
        this.root.addEventListener('change', this.queueUpdate, true);
        this.updateFields();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.observer = null;
        window.removeEventListener('builder-validate', this.queueUpdate);
        this.root?.removeEventListener('change', this.queueUpdate, true);
      }

      updateFields() {
        const app = this.root.querySelector('#shopaw-container-block, #shopaw-container');
        if (!app) return;
        const fields = app.querySelectorAll('[id$="image-upload-list"], [id$="image-upload"]');
        fields.forEach((field) => {
          const label = field.querySelector('.form__label');
          if (!label || !field.querySelector('input[type="file"]')) return;
          const name = label.textContent.trim();
          const artworkField = field.hasAttribute('data-lx-optional-artwork') ||
            /art\s*work|design|diseño|obra de arte|图稿|稿件|作品|設計圖|设计图/i.test(name);
          if (!artworkField) return;

          if (!field.hasAttribute('data-lx-optional-artwork')) {
            field.setAttribute('data-lx-optional-artwork', '');
          }
          if (!label.querySelector('.lx-artwork-optional-label')) {
            const optional = document.createElement('span');
            optional.className = 'lx-artwork-optional-label';
            optional.textContent = this.dataset.optionalLabel;
            label.append(optional);
          }

          let note = field.querySelector('.lx-artwork-email-note');
          if (!note) {
            note = this.noteTemplate.content.firstElementChild.cloneNode(true);
            note.id = `${this.root.id}-${field.id}-email-note`;
            field.append(note);
          }

          field.querySelectorAll('input[type="file"]').forEach((input) => {
            if (input.required) input.required = false;
            if (input.getAttribute('aria-required') !== 'false') input.setAttribute('aria-required', 'false');
            const descriptions = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
            if (!descriptions.has(note.id)) {
              descriptions.add(note.id);
              input.setAttribute('aria-describedby', Array.from(descriptions).join(' '));
            }
          });

          const uploading = Boolean(field.querySelector('.image-upload .ant-spin-spinning, .image-upload [aria-busy="true"]'));
          const status = note.querySelector('.lx-artwork-upload-status');
          status.hidden = !uploading;
          status.classList.toggle('required-error', uploading);

          field.querySelectorAll('.form__label .required-error, .form__label .lx-artwork-empty-error').forEach((error) => {
            // Shopaw places the empty-field requirement inside this file field's label.
            // File transfer/format errors outside the label and other required options stay intact.
            // Browser translation must never determine whether an option is required.
            const suppress = !uploading;
            error.classList.toggle('required-error', !suppress);
            error.classList.toggle('lx-artwork-empty-error', suppress);
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-product-guide"] && !Shopify.designMode) return;
  try {
    (() => {
  function initializeProductGuide() {
    const guide = document.querySelector('.lx-product-guide');
    if (!guide || guide.dataset.navigationReady) return;
    guide.dataset.navigationReady = 'true';
    const nav = guide.querySelector('.lx-pguide-nav');
    const header = document.querySelector('.lx-ref-header-section');
    const links = [...nav.querySelectorAll('a')];
    const sections = links.map(link => document.getElementById(link.hash.slice(1)));
    let scheduled = false;
    const refresh = () => {
      scheduled = false;
      if (!guide.isConnected) return;
      if (header) guide.style.setProperty('--lx-pguide-header-height', `${header.offsetHeight}px`);
      guide.style.setProperty('--lx-pguide-nav-height', `${nav.offsetHeight}px`);
      const edge = nav.getBoundingClientRect().bottom + 28;
      let active = sections[0];
      for (const section of sections) if (section.getBoundingClientRect().top <= edge) active = section;
      for (const link of links) {
        if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      }
    };
    const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
    const openAnchor = () => {
      const target = document.getElementById(location.hash.slice(1));
      if (!target || !guide.contains(target)) return;
      for (let parent = target; parent && parent !== guide; parent = parent.parentElement) if (parent.matches('details')) parent.open = true;
      if (target.id === 'LXBulkOrder') target.querySelector('details').open = true;
      refresh();
      target.scrollIntoView({block: 'start'});
      schedule();
    };
    guide.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#LX"]');
      if (link && link.hash === location.hash) requestAnimationFrame(openAnchor);
    });
    window.addEventListener('hashchange', openAnchor);
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    guide.addEventListener('toggle', schedule, true);
    const observer = new ResizeObserver(schedule);
    if (header) observer.observe(header);
    observer.observe(nav);
    refresh();
    openAnchor();
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(guide)) return;
      window.removeEventListener('hashchange', openAnchor);
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      observer.disconnect();
    }, {once: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeProductGuide, {once: true});
  else initializeProductGuide();
  document.addEventListener('shopify:section:load', initializeProductGuide);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-shaker-tier-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-lx-shaker-tiers]');
  const root = document.querySelector('product-info');
  if (!marker || !root) return;
  let quantityAnchor;
  let nativeQuantity;
  let scheduled = false;
  let synchronizedQuantity;
  const arrange = () => {
    scheduled = false;
    const grid = root.querySelector('[os-vd-deal-id="6aba0aced9c307236a210bd7"]');
    const currentQuantity = root.querySelector('[id^="Quantity-Form-"]');
    if (currentQuantity) nativeQuantity = currentQuantity;
    const input = nativeQuantity?.querySelector('input[name="quantity"][form]');
    if (!input) return;
    if (!grid) {
      nativeQuantity.classList.remove('lx-shaker-quantity');
      if (quantityAnchor?.isConnected && quantityAnchor.nextElementSibling !== nativeQuantity) quantityAnchor.after(nativeQuantity);
      return;
    }
    grid.classList.add('lx-shaker-tier-grid');
    if (nativeQuantity.parentElement !== grid) {
      quantityAnchor?.remove();
      quantityAnchor = document.createElement('span');
      quantityAnchor.hidden = true;
      nativeQuantity.before(quantityAnchor);
    }
    nativeQuantity.classList.add('lx-shaker-quantity');
    const firstTier = grid.querySelector('.os-vd__tier');
    if (/^\s*1(?:\D|$)/.test(firstTier?.querySelector('.os-vd__tier-title')?.textContent || '')) {
      firstTier.classList.add('lx-shaker-tier-base');
    }
    if (grid.firstElementChild !== nativeQuantity) grid.prepend(nativeQuantity);
    const variantId = root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const key = `${variantId}:${input.value}`;
    if (key !== synchronizedQuantity) {
      synchronizedQuantity = key;
      requestAnimationFrame(() => {
        if (!input.isConnected) return;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(arrange);
  };
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
  root.addEventListener('input', schedule);
  root.addEventListener('change', schedule);
  window.addEventListener('pageshow', () => { synchronizedQuantity = undefined; schedule(); });
  arrange();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-shipping-estimator"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('lx-shipping-estimator'))return;
  class LXShippingEstimator extends HTMLElement {
    connectedCallback(){
      if(this.cleanup)return;
      this.copy=JSON.parse(this.querySelector('[data-lxse-copy]').textContent);
      this.form=this.querySelector('form');this.button=this.form.querySelector('button');
      this.status=this.querySelector('[data-lxse-status]');this.rates=this.querySelector('[data-lxse-rates]');
      this.summary=this.querySelector('[data-lxse-cart]');
      this.currency=this.dataset.currency||'USD';
      const submit=event=>{event.preventDefault();this.estimate();};
      const invalidate=()=>{this.controller?.abort();this.controller=null;this.rates.replaceChildren();this.status.textContent=this.copy.stale;this.button.disabled=false;};
      const reveal=()=>{if(location.hash==='#LXShippingEstimate')this.querySelector('details').open=true;};
      const toggle=()=>{if(this.querySelector('details').open)this.loadCart().catch(()=>{this.status.textContent=this.copy.error;});};
      this.form.addEventListener('submit',submit);this.form.addEventListener('input',invalidate);
      this.querySelector('details').addEventListener('toggle',toggle);
      window.addEventListener('hashchange',reveal);
      if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined')this.unsubscribe=subscribe(PUB_SUB_EVENTS.cartUpdate,invalidate);
      this.cleanup=()=>{this.controller?.abort();this.form.removeEventListener('submit',submit);this.form.removeEventListener('input',invalidate);this.querySelector('details').removeEventListener('toggle',toggle);window.removeEventListener('hashchange',reveal);this.unsubscribe?.();};
      reveal();
    }
    async loadCart(signal){
      const response=await fetch(this.dataset.cartUrl+'.js',{credentials:'same-origin',cache:'no-store',signal});
      if(!response.ok)throw new Error('cart');
      const cart=await response.json();this.currency=cart.currency||this.dataset.currency||'USD';
      this.summary.textContent=this.copy.cart.replace('{count}',String(cart.item_count)).replace('{total}',this.money(cart.total_price/100,this.currency));
      return cart;
    }
    money(amount,currency){return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency||this.currency}).format(amount);}
    async estimate(){
      if(!this.form.reportValidity())return;
      this.controller?.abort();const controller=new AbortController();this.controller=controller;
      const timeout=setTimeout(()=>controller.abort(),25000);
      this.button.disabled=true;this.rates.replaceChildren();this.status.textContent=this.copy.loading;
      try{
        const cart=await this.loadCart(controller.signal);
        if(!cart.item_count){this.status.textContent=this.copy.empty;return;}
        const values=new FormData(this.form),params=new URLSearchParams();
        for(const field of ['country','province','zip'])params.set('shipping_address['+field+']',String(values.get(field)||'').trim());
        const prefix=this.dataset.cartUrl;
        const response=await fetch(prefix+'/prepare_shipping_rates.json?'+params,{method:'POST',credentials:'same-origin',signal:controller.signal});
        if(!response.ok)throw new Error('rates');
        let data=null;
        for(let attempt=0;attempt<10;attempt++){
          if(attempt)await new Promise(resolve=>setTimeout(resolve,1000));
          if(controller.signal.aborted)throw new Error('aborted');
          const result=await fetch(prefix+'/async_shipping_rates.json?'+params,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
          if(!result.ok)throw new Error('rates');
          data=await result.json();if(data!==null)break;
        }
        if(controller.signal.aborted)return;
        if(!data){this.status.textContent=this.copy.timeout;return;}
        const entries=Array.isArray(data.shipping_rates)?data.shipping_rates:[];
        this.status.textContent=entries.length?'':this.copy.none;
        for(const rate of entries){
          const amount=Number(rate.price);if(!Number.isFinite(amount))continue;
          const li=document.createElement('li'),name=document.createElement('span'),price=document.createElement('strong');
          name.textContent=rate.presentment_name||rate.name||'';
          price.textContent=amount===0?this.copy.free:this.money(amount,rate.currency||this.currency);
          li.append(name,price);this.rates.append(li);
        }
      }catch(error){if(this.controller===controller)this.status.textContent=controller.signal.aborted?this.copy.timeout:this.copy.error;}
      finally{clearTimeout(timeout);if(this.controller===controller)this.button.disabled=false;}
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  }
  customElements.define('lx-shipping-estimator',LXShippingEstimator);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-sticker-tier-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const marker = document.querySelector('[data-lx-sticker-tiers]');
  const root = document.querySelector('product-info');
  const source = document.querySelector('[data-lx-combined-pricing]');
  if (!marker || !root || !source) return;
  const variants = JSON.parse(source.textContent);
  let quantityAnchor, nativeQuantity, scheduled=false;
  const count=document.createElement('p'); count.className='lx-sticker-count'; count.setAttribute('role','status');
  const setText=(node,text)=>{if(node.textContent!==text)node.textContent=text;};
  const arrange=()=>{
    scheduled=false;
    const grid=root.querySelector('[os-vd-deal-id="6ab928f0d9c307236a20e686"]');
    const deal=grid?.closest('.os-vd__volume-discount-deal');
    const currentQuantity=root.querySelector('[id^="Quantity-Form-"]');
    if(currentQuantity)nativeQuantity=currentQuantity;
    const input=nativeQuantity?.querySelector('input[name="quantity"][form]');
    if(!input)return;
    const quantity=Number(input.value);
    const id=root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    const variant=variants.find(v=>String(v.id)===String(id));
    const hasTiers=Boolean(variant?.tiers?.length);
    const valid=Number.isInteger(quantity)&&quantity>0&&input.validity.valid;
    setText(count,valid?`${quantity} ${marker.dataset.setLabel} = ${quantity*10} ${marker.dataset.pieceLabel}`:'');
    const label=nativeQuantity.querySelector('label');
    if(label)setText(label,marker.dataset.quantityLabel);
    if(deal){deal.hidden=!hasTiers;}
    if(!grid||!hasTiers){
      nativeQuantity.classList.remove('lx-sticker-quantity');
      if(quantityAnchor?.isConnected&&quantityAnchor.nextElementSibling!==nativeQuantity)quantityAnchor.after(nativeQuantity);
      if(count.previousElementSibling!==nativeQuantity)nativeQuantity.after(count);
    }else{
      grid.classList.add('lx-sticker-tier-grid');
      if(nativeQuantity.parentElement!==grid){quantityAnchor?.remove();quantityAnchor=document.createElement('span');quantityAnchor.hidden=true;nativeQuantity.before(quantityAnchor);}
      nativeQuantity.classList.add('lx-sticker-quantity');
      const first=grid.querySelector('.os-vd__tier');
      if(/^\s*1(?:\D|$)/.test(first?.querySelector('.os-vd__tier-title')?.textContent||''))first.classList.add('lx-sticker-tier-base');
      grid.querySelectorAll('.os-vd__tier-title').forEach(title=>{const minimum=title.textContent.match(/\d+/)?.[0];if(minimum)setText(title,`${minimum}+ ${marker.dataset.setLabel}`);});
      if(grid.firstElementChild!==nativeQuantity)grid.prepend(nativeQuantity);
      if(count.previousElementSibling!==grid)grid.after(count);
    }
  };
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(arrange);};
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
  root.addEventListener('input',schedule);root.addEventListener('change',schedule);
  window.addEventListener('pageshow',schedule);
  arrange();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lx-sticky-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  if(customElements.get('lx-sticky-controls')) return;
  class LXStickyControls extends HTMLElement {
    connectedCallback(){
      if(this.cleanup) return;
      const bar=document.getElementById(this.dataset.bar);
      const collapse=bar?.querySelector('.lx-sticky-collapse');
      const expand=this.querySelector('.lx-sticky-expand');
      if(!bar||!collapse||!expand) return;
      const close=()=>{
        bar.setAttribute('data-lx-collapsed','');
        expand.hidden=false;
        document.documentElement.style.setProperty('--atc-bar-height','0px');
        expand.focus({preventScroll:true});
      };
      const open=()=>{
        bar.removeAttribute('data-lx-collapsed');
        bar.classList.add('atc-visible');
        expand.hidden=true;
        requestAnimationFrame(()=>collapse.focus({preventScroll:true}));
      };
      collapse.addEventListener('click',close);
      expand.addEventListener('click',open);
      this.cleanup=()=>{collapse.removeEventListener('click',close);expand.removeEventListener('click',open);bar.removeAttribute('data-lx-collapsed');};
    }
    disconnectedCallback(){this.cleanup?.();this.cleanup=null;}
  }
  customElements.define('lx-sticky-controls',LXStickyControls);
})();
  } catch(e) { console.error(e); }
})();

})();
